import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GroupsModal.css';
import BASE_URL from '../utils/api';

// Simple modal that lists ALL groups (read-only) and navigates to a group's page when clicked
export default function AllGroupsModal({ onClose, apiCall }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const getName = (g) => (g && (g.NomeGrupo || g.nomeGrupo || g.Nome || g.nome || g.name || '')) + '';

  const fetchGroups = async () => {
    setLoading(true); setError('');
    try {
      let data;
      if (typeof apiCall === 'function') data = await apiCall('Grupo', 'GET');
      else {
        const headers = {};
        const token = localStorage.getItem('authToken');
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const res = await fetch(`${BASE_URL}/Grupo`, { headers });
        const text = await res.text();
        try { data = JSON.parse(text); } catch { data = text; }
      }
      const arr = Array.isArray(data) ? data : (data?.Grupos || data?.grupos || []);
      setGroups(arr || []);
      if (!arr || arr.length === 0) setError('Nenhum grupo encontrado');
    } catch (e) { console.error('Erro carregar grupos (all modal)', e); setError('Não foi possível carregar grupos.'); setGroups([]); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchGroups(); }, []);

  const filtered = groups.filter(g => !query || getName(g).toLowerCase().includes(query.toLowerCase()));

  const openGroup = (g) => {
    try { navigate('/sidebar/GrupoDropDown', { state: { selectedGroup: g } }); } catch {}
    onClose && onClose();
  };

  return (
    <div className="groups-modal-overlay" role="dialog" aria-modal="true" onClick={(e)=>{ if (e.target.classList && e.target.classList.contains('groups-modal-overlay')) onClose(); }}>
      <div className="groups-modal" onClick={(e)=>e.stopPropagation()}>
        <div className="groups-modal-header">
          <div style={{ fontWeight: 700 }}>Grupos</div>
          <button className="modal-close-btn" onClick={onClose} aria-label="Fechar">×</button>
        </div>

        <div style={{ marginTop: 8 }}>
          <input className="groups-modal-search" placeholder="Pesquisar grupos..." value={query} onChange={(e)=>setQuery(e.target.value)} />
        </div>

        <div className="groups-modal-body">
          {loading && <div className="groups-modal-empty">Carregando...</div>}
          {error && !loading && <div className="groups-modal-empty">{error}</div>}
          {!loading && !error && filtered.length === 0 && <div className="groups-modal-empty">Nenhum grupo encontrado</div>}

          <ul className="groups-modal-list">
            {filtered.map(g => {
              const id = g.Id || g.id || g.GrupoId || getName(g);
              return (
                <li key={id} className={`groups-modal-item`} onClick={()=>openGroup(g)} onKeyDown={(e)=>{ if (e.key === 'Enter') openGroup(g); }} tabIndex={0}>
                  <div className="groups-modal-item-title">{getName(g)}</div>
                  {g.Descricao && <div className="groups-modal-item-desc">{g.Descricao}</div>}
                </li>
              );
            })}
          </ul>

          <div className="groups-modal-footer" style={{ justifyContent: 'flex-end' }}>
            <button className="modal-cancel-btn" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}